import type { RequestInfo } from '@warp-drive/core/types/request';
import { buildBaseURL } from '@warp-drive/utilities';
import { SkipCache } from '@warp-drive/core-types/request';

/**
 * GET /api/v2/search/datasets — the OpenSearch dataset catalog for Report
 * Builder, scoped by the backend to datasets the current user may query.
 * Responds with a CommandResponse envelope, NOT a JSONAPI resource: read
 * `content.data.attributes.result.availableDatasets`. Uncached (`SkipCache`):
 * the catalog is user-scoped and every host route refetches it per session
 * rather than reading a shared cache entry.
 */
export function searchDatasetsRequest(): RequestInfo {
  const url = `${buildBaseURL({ resourcePath: 'api/v2/search/datasets' })}`;
  return { url, method: 'GET', cacheOptions: { [SkipCache]: true } };
}
